/**
 * Agent shell — nav mirrors app_router.dart:131-137 plus the child routes at
 * app_router.dart:218-283.
 *
 * `Expenses` has no Flutter counterpart in this list (the app_router.dart nav
 * table predates the module), but the backend's `buildScope(user, 'expense')`
 * does grant AGENT access — property owner OR assigned agent is the
 * documented rule elsewhere, but expenses' AGENT branch is `assigned_agent`
 * only, no owner fallback (see "Agent scoping is inconsistent" in
 * refactor/docs/PARITY_NOTES.md). That is still real, reachable access, so the
 * nav item is added here even though Flutter never surfaced one.
 */
import {
  Dashboard,
  Building,
  UserMultiple,
  Money,
  ToolBox,
  Receipt,
  Logout,
  Chat,
  Send,
  ChartBar,
  Settings,
  WarningAlt,
} from '@carbon/icons-react';
import { ShellFrame, type NavItem } from './ShellFrame';

const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Dashboard', to: '/agent', end: true, icon: Dashboard },
  { label: 'Properties', to: '/agent/properties', icon: Building },
  { label: 'Tenants', to: '/agent/tenants', icon: UserMultiple },
  { label: 'Billing', to: '/agent/billing', icon: Money },
  { label: 'Maintenance', to: '/agent/maintenance', icon: ToolBox },
  { label: 'Expenses', to: '/agent/expenses', icon: Receipt },
  { label: 'Offboarding', to: '/agent/offboarding', icon: Logout },
  { label: 'Messages', to: '/agent/messages', icon: Chat },
  { label: 'Eviction notices', to: '/agent/eviction-notices', icon: WarningAlt },
  { label: 'Broadcasts', to: '/agent/broadcasts', icon: Send },
  { label: 'Reports', to: '/agent/reports', icon: ChartBar },
  { label: 'Settings', to: '/agent/settings', icon: Settings },
];

export function AgentShell(): React.JSX.Element {
  return <ShellFrame title="Agent" navItems={NAV_ITEMS} />;
}

export default AgentShell;
